import apiFetch from '../apiFetch'

export default function (idTransportista) {
  return apiFetch({endPoint: `Combos/getComboVehiculosTransportistaDeterminado?idTransportista=${idTransportista}`, method: 'GET', body: null})
}